import { render, staticRenderFns } from "./p2pCallLog.vue?vue&type=template&id=2054e92b&"
import script from "./p2pCallLog.vue?vue&type=script&lang=js&"
export * from "./p2pCallLog.vue?vue&type=script&lang=js&"
import style0 from "./p2pCallLog.vue?vue&type=style&index=0&id=2054e92b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports